import { render, staticRenderFns } from "./PriceDetailsPopup.vue?vue&type=template&id=1a868f5c&scoped=true"
import script from "./PriceDetailsPopup.vue?vue&type=script&lang=js"
export * from "./PriceDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./PriceDetailsPopup.vue?vue&type=style&index=0&id=1a868f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a868f5c",
  null
  
)

export default component.exports